import { BankTransactions } from './BankTransactions';

export const Banks = BankTransactions;
